AFRAME.registerSystem('iframe', {
	init: function () {},
});
